import { DatePicker } from "@material-ui/pickers";
import { downloadPaymentList } from "src/pages/Payment/redux/list";
import { useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";

// import { push } from 'redux-first-history'

function MyModal({ open, onClose }) {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSetStartDate = (e) => {
    setStartDate(e);
  };

  const handleSetEndDate = (e) => {
    setEndDate(e);
  };

  const handleDownload = () => {
    dispatch(downloadPaymentList({ start_date: startDate, end_date: endDate }));
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open}>
      <Box p={4}>
        <Box mb={3} fontSize="20px">
          Download Invoices
        </Box>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <DatePicker
              value={startDate}
              onChange={handleSetStartDate}
              placeholder="Select"
              openTo="year"
              format="dd/MM/yyyy"
              label="Start Date"
              views={["year", "month", "date"]}
              inputVariant="outlined"
              size="small"
              invalidDateMessage={null}
              fullWidth
              disableFuture
              autoOk
              clearable
            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker
              value={endDate}
              onChange={handleSetEndDate}
              placeholder="Select"
              openTo="year"
              format="dd/MM/yyyy"
              label="End Date"
              views={["year", "month", "date"]}
              inputVariant="outlined"
              size="small"
              invalidDateMessage={null}
              fullWidth
              disableFuture
              autoOk
              clearable
            />
          </Grid>
        </Grid>
        <Box display={"flex"} justifyContent="flex-end" mt={5}>
          <Button
            disableElevation
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            cancel
          </Button>
          <Box ml={2}>
            <Button
              disableElevation
              variant="contained"
              color="primary"
              onClick={handleDownload}
            >
              download
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default MyModal;
